import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function TestimonialsSection() {
  return <section className="w-full bg-cream-100 px-6 py-20 sm:py-24" aria-labelledby="testimonios-titulo" data-id="element-179" data-mp="1n0aifuwodh2y">
      <div className="mx-auto max-w-6xl" data-id="element-180" data-mp="1r1422c3349q1">
        <div id="testimonios-titulo" data-id="element-181" data-mp="1r02oo0yljb55">
          <SectionHeading eyebrow="Testimonios" title="Lo que dicen quienes ya lo tienen" data-id="element-182" data-mp="1d1uqjpptq3se" />
        </div>

        <ul className="mx-auto mt-14 grid max-w-4xl gap-6 md:grid-cols-2" data-id="element-183" data-mp="1i0o4fj90vwt3">
          {testimonials.map(({
          quote,
          initials,
          name,
          role
        }) => <li key={name} className="flex h-full flex-col rounded-2xl bg-white p-8 shadow-card" data-id="element-184" data-mp="142r3ybrg7695">
              <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-185" data-mp="1839y4cgtcoei">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" aria-hidden="true" data-id="element-186" data-mp="2yd32skn4z38z" />)}
              </span>
              <blockquote className="mt-5 text-base leading-relaxed text-forest-700/85" data-id="element-187" data-mp="2v0sw7ddrmc5h">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 pt-8" data-id="element-188" data-mp="2q1gawx2jld50">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-forest-600 text-sm font-bold text-cream-50" data-id="element-189" data-mp="34r4a9sr5y1q3">
                  {initials}
                </span>
                <div data-id="element-190" data-mp="2c2qdfgbt9bg4">
                  <p className="font-semibold text-forest-800" data-id="element-191" data-mp="2c26vw0q2op2m">{name}</p>
                  <p className="text-sm text-forest-700/60" data-id="element-192" data-mp="273n6trg6mx61">{role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}